import { Monitor, Megaphone, Compass, Store, Users } from "lucide-react";
import { PROGRAMS_DATA } from "../data";

export default function Programs() {
  // Icon mapper helper
  const renderIcon = (iconName: string) => {
    const iconClass = "w-6 h-6 text-white";
    switch (iconName) {
      case "Monitor":
        return <Monitor className={iconClass} />;
      case "Megaphone":
        return <Megaphone className={iconClass} />;
      case "Compass":
        return <Compass className={iconClass} />;
      case "Store":
        return <Store className={iconClass} />;
      case "Users":
        return <Users className={iconClass} />;
      default:
        return <Monitor className={iconClass} />;
    }
  };

  return (
    <section id="profil" className="py-20 bg-slate-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section title aligned to design standards */}
        <div className="text-center space-y-2 mb-14">
          <h2 className="text-3xl font-extrabold text-[#005c32] tracking-tight font-sans">
            PROGRAM UNGGULAN
          </h2>
          {/* Yellow underline accent */}
          <div className="w-24 h-1 bg-[#ffd22e] mx-auto rounded-full" />
          <p className="text-sm text-slate-500 font-medium max-w-md mx-auto pt-1">
            Program inovasi lingkungan terintegrasi menuju RW mandiri dan modern
          </p>
        </div>

        {/* 4 horizontal cards layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {PROGRAMS_DATA.map((item) => (
            <div 
              key={item.id} 
              className="group bg-white rounded-3xl p-6 border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-[#005c32]/5 hover:border-[#005c32]/25 hover:-translate-y-1.5 transition-all duration-300 ease-out flex flex-col justify-between"
            >
              <div className="space-y-4">
                {/* Circle green shape icon */}
                <div className="w-12 h-12 rounded-full bg-[#005c32] flex items-center justify-center shadow-md shadow-[#005c32]/20 transition-all duration-300 ease-out group-hover:scale-110 group-hover:bg-[#00733f]">
                  {renderIcon(item.iconName)}
                </div>

                <div className="space-y-2">
                  <h3 className="text-base font-extrabold text-[#005c32] tracking-tight">
                    {item.title}
                  </h3>
                  <p className="text-xs text-slate-500 leading-relaxed font-semibold">
                    {item.description}
                  </p>
                </div>
              </div>

              {/* Little visual touch indicator */}
              <div className="pt-4 mt-4 border-t border-slate-100 flex items-center text-[10px] font-bold text-[#ffd22e] tracking-widest uppercase">
                <span className="bg-[#ffd22e]/10 text-[#a37f00] px-2.5 py-1 rounded-md">AKTIF &bull; DIGITAL</span>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
